import { CircleAlert } from 'lucide-react';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';
import { ERROR_FEEDBACK } from '@/utils/constants';

interface ReleaseNoteMenuFooterErrorProps {
  onRetry: () => void;
}

const ReleaseNoteMenuFooterError: FC<ReleaseNoteMenuFooterErrorProps> = ({ onRetry }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full items-center justify-between gap-3 px-5">
      <div className="flex items-center gap-2">
        <CircleAlert className="size-6 shrink-0 fill-destructive text-white" />
        <p className="text-sm text-foreground">{t(ERROR_FEEDBACK.release_note.api)}</p>
      </div>
      <Button variant="default" onClick={onRetry} className="shrink-0">
        {t('common.reload')}
      </Button>
    </div>
  );
};

export default ReleaseNoteMenuFooterError;
